//Components
import Layout from '../../hocs/Layout';
import { useEffect,useState } from 'react';
import { PriceForm } from '../../components/aditional/PriceForm';
//Styles
import '../../styles/services.css';


const DigitalMarketing = () => {

	const [openPriceForm, setOpenPriceForm] = useState(false);
	
	const toggleOpenForm = () => {
    	setOpenPriceForm(!openPriceForm);
    }

	useEffect(() => {
		window.scrollTo(0,0);
	}, []);

	return (

		<Layout>
			<div className='container-webd-header'>
				<h3 className='title-max'>Marketing Digital</h3>
				<p className='webd-header-text'>Impulsamos tu negocio con estrategias digitales efectivas y medibles</p>
				<div className='contain-webd-boxes'>
					<div className='webd-box'>
						<img src={require(`../../images/meta.webp`)} alt='meta' />
						<h4>Publicidad en redes sociales</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/correo-electronico.webp`)} alt='correo-electronico' />
						<h4>Estrategias de email marketing</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/optimizacion-seo.webp`)} alt='optimizacion-seo' />
						<h4>Optimización SEO para aumentar visibilidad</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/copywriting.webp`)} alt='copywriting' />
						<h4>Gestión de contenido y copywriting</h4>
					</div>
				</div>
				<div className='container-webd-profit'>
					<h3 className='home-titles-white'>Beneficios principales</h3>
					<div className='container-profits-boxes'>
						<div className='container-profits-box'>
							<img src={require(`../../images/cheque.webp`)} alt='cheque'  className='process-img' />
							<h3 className='process-text'>Estrategias enfocadas en conversión</h3>
						</div>
						<div className='container-profits-box'>
							<img src={require(`../../images/analitica.webp`)} alt='analitica'  className='process-img' />
							<h3 className='process-text'>Reportes mensuales claros y comprensibles</h3>
						</div>
						<div className='container-profits-box'>
							<img src={require(`../../images/apreton.webp`)} alt='apreton'  className='process-img' />
							<h3 className='process-text'>Atención personalizada</h3>
						</div>
					</div>
					<button className='btn btn1' onClick={toggleOpenForm} style={{textDecoration:'none'}}>Solicitar una cotización</button>
				</div>
			<PriceForm toggleOpen={toggleOpenForm} openPriceForm={openPriceForm} />
			</div>
			<div className='container-webd-process'>
				<h3 className='home-titles-white'>Nuestro proceso</h3>
				<div className='container-process-boxes'>
	      			<div className='container-process-box'>
						<img src={require(`../../images/planificacion.webp`)} alt='planificacion'  className='process-img' />
						<h3 className='process-text'>Análisis de negocio</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/analisis.webp`)} alt='analisis'  className='process-img' />
						<h3 className='process-text'>Plan de marketing</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/configuracion.webp`)} alt='configuracion'  className='process-img' />
						<h3 className='process-text'>Ejecución y seguimiento</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/optimizacion.webp`)} alt='optimizacion'  className='process-img' />
						<h3 className='process-text'>Reportes y optimización</h3>
					</div>
	    		</div>
    		</div>
		</Layout>
	);
};

export default DigitalMarketing